export default "__VITE_ASSET__BDoWhlSo__"